/**
 * MobileBottomNav Component
 * 
 * Sticky bottom navigation bar for mobile devices.
 * Shows My Values, Collections, and Favorites buttons.
 * Only visible on mobile screens (< 768px).
 * 
 * @author OriginSelect Team
 * @created December 2, 2025
 */

import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useUser } from '../context/UserContext';
import './MobileBottomNav.css';

function MobileBottomNav() {
  const location = useLocation();
  const { user } = useUser();
  
  // Determine if we're in global or country context
  const isGlobal = location.pathname.startsWith('/global');
  const basePath = isGlobal ? '/global' : '/country/canada';

  // Debug log
  console.log('[MobileBottomNav] Rendering, path:', location.pathname);

  // Don't show on certain pages (login, signup, checkout, cart)
  const hiddenPaths = ['/login', '/signup', '/checkout', '/cart'];
  const shouldHide = hiddenPaths.some(path => location.pathname.includes(path));
  
  if (shouldHide) {
    console.log('[MobileBottomNav] Hidden due to path');
    return null;
  }

  return (
    <nav className="mobile-bottom-nav">
      <NavLink 
        to={`${basePath}/my/values`}
        className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
      >
        <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
        </svg>
        <span className="nav-label">My Values</span>
      </NavLink>

      <NavLink 
        to={`${basePath}/baby-registry/my`}
        className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
      >
        <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <polyline points="20 12 20 22 4 22 4 12"/>
          <rect x="2" y="7" width="20" height="5"/>
          <line x1="12" y1="22" x2="12" y2="7"/>
          <path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/>
          <path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/>
        </svg>
        <span className="nav-label">My Registry</span>
      </NavLink>

      <NavLink 
        to={`${basePath}/favorites`}
        className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
      >
        <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
        </svg>
        <span className="nav-label">Favorites</span>
      </NavLink>

      {!user && (
        <NavLink 
          to={`${basePath}/login`}
          className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
        >
          <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
            <circle cx="12" cy="7" r="4"/>
          </svg>
          <span className="nav-label">Sign In</span>
        </NavLink>
      )}
    </nav>
  );
}

export default MobileBottomNav;
